module.exports = __webpack_public_path__ + "img/party_bg.028fc0b8.png";